document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initCustomerStories, 100);

  function initCustomerStories() {
    const storiesBlocks = document.querySelectorAll('.customer-stories');

    storiesBlocks.forEach((block, blockIndex) => {
      const slider = block.querySelector('.customer-stories__slider');
      const progressBar = block.querySelector('.customer-stories__progress-bar');
      const progressContainer = block.querySelector('.customer-stories__progress-container');

      if (slider && progressBar && progressContainer) {
        let isDragging = false;

        // Update scrollbar position based on slider scroll
        function updateScrollbar() {
          const sliderWidth = slider.clientWidth;
          const scrollWidth = slider.scrollWidth;
          const maxScrollLeft = scrollWidth - sliderWidth;

          if (maxScrollLeft <= 0) {
            // Content fits in viewport - show full width thumb
            progressBar.style.width = '100%';
            progressBar.style.left = '0';
            return;
          }

          // Calculate thumb width as percentage
          const thumbWidthPercent = (sliderWidth / scrollWidth) * 100;

          // Calculate scroll progress (0 to 1)
          const scrollRatio = slider.scrollLeft / maxScrollLeft;

          // Calculate thumb position (only travels within available space)
          const maxThumbTravel = 100 - thumbWidthPercent;
          const thumbLeftPercent = scrollRatio * maxThumbTravel;

          progressBar.style.width = `${thumbWidthPercent}%`;
          progressBar.style.left = `${thumbLeftPercent}%`;
        }

        // Scroll slider based on click/drag position
        function scrollToPosition(clientX) {
          const rect = progressContainer.getBoundingClientRect();
          const relativeX = clientX - rect.left;

          const sliderWidth = slider.clientWidth;
          const scrollWidth = slider.scrollWidth;
          const maxScrollLeft = scrollWidth - sliderWidth;

          if (maxScrollLeft <= 0) return;

          // Calculate thumb width in pixels
          const thumbWidthPx = (sliderWidth / scrollWidth) * rect.width;

          // Calculate where the thumb should start (centering thumb on click)
          let thumbLeftPx = relativeX - (thumbWidthPx / 2);

          // Maximum travel distance for thumb
          const maxThumbLeftPx = rect.width - thumbWidthPx;

          // Calculate scroll ratio
          let scrollRatio = thumbLeftPx / maxThumbLeftPx;
          scrollRatio = Math.max(0, Math.min(1, scrollRatio));

          // Apply scroll
          slider.scrollLeft = scrollRatio * maxScrollLeft;
        }

        // Listen for slider scroll
        slider.addEventListener('scroll', updateScrollbar);
        window.addEventListener('resize', updateScrollbar);

        // Mouse drag handlers
        progressContainer.addEventListener('mousedown', (e) => {
          isDragging = true;
          progressContainer.classList.add('is-dragging');
          scrollToPosition(e.clientX);
          e.preventDefault();
        });

        document.addEventListener('mousemove', (e) => {
          if (isDragging) {
            scrollToPosition(e.clientX);
            e.preventDefault();
          }
        });

        document.addEventListener('mouseup', () => {
          if (isDragging) {
            isDragging = false;
            progressContainer.classList.remove('is-dragging');
          }
        });

        // Touch drag handlers
        let touchStarted = false;

        progressContainer.addEventListener('touchstart', (e) => {
          touchStarted = true;
          isDragging = true;
          progressContainer.classList.add('is-dragging');
          if (e.touches.length > 0) {
            scrollToPosition(e.touches[0].clientX);
          }
          e.preventDefault();
        }, { passive: false });

        document.addEventListener('touchmove', (e) => {
          if (isDragging && touchStarted && e.touches.length > 0) {
            scrollToPosition(e.touches[0].clientX);
            e.preventDefault();
          }
        }, { passive: false });

        document.addEventListener('touchend', () => {
          if (touchStarted) {
            isDragging = false;
            touchStarted = false;
            progressContainer.classList.remove('is-dragging');
          }
        });

        // Initial updates with multiple retries to ensure rendering
        setTimeout(updateScrollbar, 100);
        setTimeout(updateScrollbar, 300);
        setTimeout(updateScrollbar, 500);
        setTimeout(updateScrollbar, 1000);
      }

      // Video play/pause logic
      const cards = block.querySelectorAll('.customer-story__card');
      cards.forEach(card => {
        card.addEventListener('click', function () {
          const video = this.querySelector('video');
          const icon = this.querySelector('.customer-story__play-icon');

          if (video) {
            if (video.paused) {
              // Pause all other videos
              block.querySelectorAll('video').forEach(v => {
                if (v !== video && !v.paused) {
                  v.pause();
                  const otherIcon = v.closest('.customer-story__card')?.querySelector('.customer-story__play-icon');
                  if (otherIcon) otherIcon.style.opacity = '1';
                }
              });

              video.play();
              if (icon) icon.style.opacity = '0';
            } else {
              video.pause();
              if (icon) icon.style.opacity = '1';
            }
          }
        });
      });
    });
  }
});
